import { Box, Button, styled } from '@mui/material';
import { LoadingButton } from 'components';

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(2),
    flexDirection: 'column',
  },
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(4),
}));

export const GoBackButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('md')]: { width: '100%', order: 2 },
}));
GoBackButton.defaultProps = {
  variant: 'outlined',
};

export const SubmitButton = styled(LoadingButton)(({ theme }) => ({
  height: theme.spacing(5.25),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    order: 2,
    padding: theme.spacing(0),
  },
}));
SubmitButton.defaultProps = {
  variant: 'rounded',
};
